/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_100_DescInputs */

const es_gift_option_100_desc = /** @type {(inputs: Gift_Option_100_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya sabes hacer un as de guía (a veces).`)
};

const gl_gift_option_100_desc = /** @type {(inputs: Gift_Option_100_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xa sabes facer un as de guía (ás veces).`)
};

const en_gift_option_100_desc = /** @type {(inputs: Gift_Option_100_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can tie a bowline (sometimes).`)
};

/**
* | output |
* | --- |
* | "You can tie a bowline (sometimes)." |
*
* @param {Gift_Option_100_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_100_desc = /** @type {((inputs?: Gift_Option_100_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_100_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_100_desc(inputs)
	if (locale === "en") return en_gift_option_100_desc(inputs)
	return es_gift_option_100_desc(inputs)
});